import {
  MENTOLOGY_SERVICE_AGREEMENT_BODY,
  MENTOLOGY_SERVICE_AGREEMENT_TITLE,
  SERVICE_AGREEMENT_DECLARATION_TEXT,
  SERVICE_AGREEMENT_MANDATORY_DECLARATION_HEADING,
} from '../lib/serviceAgreement';
import './ServiceAgreementPanel.css';

interface ServiceAgreementPanelProps {
  agreed: boolean;
  onAgreedChange: (agreed: boolean) => void;
  variant?: 'compact' | 'org';
  /** When true, render agreement text only (external checkboxes handle declaration). */
  hideDeclaration?: boolean;
}

export default function ServiceAgreementPanel({
  agreed,
  onAgreedChange,
  variant = 'compact',
  hideDeclaration = false,
}: ServiceAgreementPanelProps) {
  const panelClass = variant === 'org'
    ? 'service-agreement-panel service-agreement-panel-org'
    : 'service-agreement-panel service-agreement-panel-compact';

  return (
    <div className={panelClass}>
      <div className="service-agreement-scroll overflow-y-auto h-agreement-scroll">
        <p className="service-agreement-title">{MENTOLOGY_SERVICE_AGREEMENT_TITLE}</p>
        <p className="service-agreement-body scannable-bullet-text">{MENTOLOGY_SERVICE_AGREEMENT_BODY}</p>
      </div>
      {!hideDeclaration && (
        <div className="service-agreement-declaration-block">
          <p className="service-agreement-declaration-heading">
            {SERVICE_AGREEMENT_MANDATORY_DECLARATION_HEADING}
          </p>
          <label className="service-agreement-declaration">
            <input
              type="checkbox"
              checked={agreed}
              onChange={(event) => onAgreedChange(event.target.checked)}
            />
            <span>{SERVICE_AGREEMENT_DECLARATION_TEXT}</span>
          </label>
        </div>
      )}
    </div>
  );
}
